import PropTypes from 'prop-types';

export const SoldToPropType = PropTypes.shape({
  customerId: PropTypes.string,
  email: PropTypes.string,
  name: PropTypes.string,
  phone: PropTypes.string,
  username: PropTypes.string,
});

/**
 * @typedef {object} SoldToPropType
 * @property {string} customerId
 * @property {string} email
 * @property {string} name
 * @property {string} phone
 * @property {string} username
 */
